import { prepareTheme } from 'presentation/main/themes/prepareTheme'
import { darkColors } from './colors.dark.theme'

export const darkTheme = prepareTheme('dark' as const, darkColors)
